import { render } from "./PokedexHome.vue?vue&type=template&id=7280904b&scoped=true"
import script from "./PokedexHome.vue?vue&type=script&lang=js"
export * from "./PokedexHome.vue?vue&type=script&lang=js"

import "./PokedexHome.vue?vue&type=style&index=0&id=7280904b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7280904b"]])

export default __exports__